import { render, staticRenderFns } from "./DadosEndereco.vue?vue&type=template&id=53c72332&scoped=true"
import script from "./DadosEndereco.vue?vue&type=script&lang=js"
export * from "./DadosEndereco.vue?vue&type=script&lang=js"
import style0 from "./DadosEndereco.vue?vue&type=style&index=0&id=53c72332&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c72332",
  null
  
)

export default component.exports